"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
require("./Styles/Locations.css");
var EventHandlerService_1 = require("../../../../Services/EventHandlerService");
var Types_1 = require("./Types");
var Util_1 = require("../../../../Services/Util");
var Endpoints_1 = require("../../../../Utils/Endpoints");
var AuthenticationService_1 = require("../../../../Services/AuthenticationService");
var react_bootstrap_table_next_1 = require("react-bootstrap-table-next");
var react_bootstrap_table2_paginator_1 = require("react-bootstrap-table2-paginator");
var getColumns = function (apiProvider, resources) {
    if (apiProvider === "Ssr") {
        return [{
                dataField: 'Name',
                text: resources.LocationName,
                sort: true,
                style: {
                    verticalAlign: 'middle'
                }
            }, {
                dataField: 'Actions',
                text: '',
                sort: false,
                style: {
                    verticalAlign: 'middle'
                },
                headerStyle: {
                    width: '20%'
                }
            }];
    }
    else {
        return [{
                dataField: 'Name',
                text: resources.LocationName,
                sort: true,
                style: {
                    verticalAlign: 'middle'
                }
            }, {
                dataField: 'Type',
                text: resources.LocationType,
                sort: true,
                style: {
                    verticalAlign: 'middle'
                }
            }, {
                dataField: 'Actions',
                text: '',
                sort: false,
                style: {
                    verticalAlign: 'middle'
                },
                headerStyle: {
                    width: '20%'
                }
            }];
    }
};
var defaultSorted = [{
        dataField: 'Name',
        order: 'asc'
    }];
var Locations = /** @class */ (function (_super) {
    __extends(Locations, _super);
    function Locations(props) {
        var _this = _super.call(this, props) || this;
        _this.addActionsToLocationData = function (locationData) {
            locationData.map(function (location) {
                //console.log(location);
                //console.log(location.Name)
                location.Actions = (React.createElement("div", { style: {
                        display: 'flex', justifyContent: 'space-evenly', lineHeight: '2.5', color: "transparent"
                    } },
                    _this.props.applicationData.apiProvider === "Ssr" && ""
                //disabling the edit location option for now
                //
                //<Button color="primary" onClick={() => {
                //    //console.log("edit clicked");
                //    EventHandlerProvider.GetInstance().AddEvent(
                //        EditLocationEvent(location.Name, this.clientIdRef, this.clientSecretRef)
                //    );
                //}}>
                //    <FontAwesomeIcon icon={faEdit} />
                //</Button>
                ,
                    _this.props.applicationData.selectedLocation != location.Name ?
                        React.createElement(reactstrap_1.Button, { color: "danger", onClick: function () {
                                //console.log("delete clicked");
                                EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.DeleteLocationEvent(location.Name, _this.updateCallback, _this.props.applicationData.resources));
                            } },
                            React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTrash }))
                        :
                            "."));
            });
            return locationData;
        };
        _this.toggle = function (location) {
            //console.log(location);
            //console.log(location != undefined);
            if (location != undefined) {
                _this.setState({
                    currentLocation: location
                });
            }
            _this.setState(function (prevState) {
                return {
                    modal: !prevState.modal
                };
            }, function () {
                var closeButton = document.getElementsByClassName("close")[0];
                if (closeButton != null || closeButton != undefined) {
                    closeButton.style.display = "none";
                }
            });
        };
        _this.changePage = function (newPage) {
            _this.setState({
                page: newPage
            });
        };
        _this.updateCallback = function (updateSelectedLocation) {
            if (updateSelectedLocation === void 0) { updateSelectedLocation = ""; }
            //console.log("Update Callback Locations.tsx");
            Util_1.getJson(Endpoints_1.default.GetLocations, undefined, true, new Util_1.UserRequestHeaders(AuthenticationService_1.Auth.getUser()))
                .then(function (response) {
                var value = JSON.parse(response);
                _this.props.applicationData.updateCallback("locations", value);
                var totalPages = Math.ceil(value.length / 10);
                var page = _this.state.page <= totalPages ? _this.state.page : totalPages;
                _this.setState({
                    page: page,
                    totalPages: totalPages,
                    parseLocationData: true
                });
            }).catch(function (reason) {
                return console.error("Error loading locations, with reason: " + reason);
            });
            if (updateSelectedLocation != "") {
                _this.props.applicationData.updateCallback(AuthenticationService_1.AuthenticationService.selectedLocationKey, updateSelectedLocation);
            }
        };
        _this.state = {
            modal: false,
            currentLocation: undefined,
            page: 1,
            totalPages: Math.ceil(props.applicationData.locations.length / 10),
            locationData: _this.addActionsToLocationData(props.applicationData.locations),
            parseLocationData: false
        };
        _this.clientIdRef = React.createRef();
        _this.clientSecretRef = React.createRef();
        _this.deleteLocationRef = React.createRef();
        _this.locationNameRef = React.createRef();
        _this.locationNameFeedbackRef = React.createRef();
        _this.clientIdFeedbackRef = React.createRef();
        _this.clientSecretFeedbackRef = React.createRef();
        return _this;
    }
    Locations.prototype.componentDidUpdate = function () {
        if (this.state.parseLocationData) {
            this.setState({
                locationData: this.addActionsToLocationData(this.props.applicationData.locations),
                parseLocationData: false
            });
        }
    };
    Locations.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "my-1" },
            React.createElement("div", { className: "my-2 fv-c" },
                React.createElement("h2", null, this.props.applicationData.resources.Locations),
                React.createElement(reactstrap_1.Button, { className: "locations-add-btn ml-3", color: "primary", onClick: function () {
                        EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.AddLocationEvent(_this.updateCallback, _this.props.applicationData));
                    } },
                    " ",
                    this.props.applicationData.resources.AddNewLocation,
                    " ")),
            React.createElement(react_bootstrap_table_next_1.default, { bootstrap4: true, condensed: true, hover: true, bordered: false, keyField: "Name", data: this.state.locationData, columns: getColumns(this.props.applicationData.apiProvider, this.props.applicationData.resources), defaultSorted: defaultSorted, pagination: react_bootstrap_table2_paginator_1.default() })));
    };
    return Locations;
}(React.Component));
exports.Locations = Locations;
//# sourceMappingURL=Locations.js.map